import { useTranslation } from "react-i18next";

interface LoadingOverlayProps {
  visible: boolean
  message?: string
}

export function LoadingOverlay({
  visible,
  message,
}: LoadingOverlayProps) {
  const { t } = useTranslation();
  const displayMessage = message ?? t("common.processingAI");

  if (!visible) return null

  return (
    <div className="fixed inset-0 z-[999999] flex items-center justify-center bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm transition-all duration-300">
      <div className="flex flex-col items-center">

        {/* SPINNER */}
        <div className="relative flex items-center justify-center">
          {/* Outer Glow */}
          <div className="absolute w-20 h-20 bg-brand-500/20 rounded-full blur-xl animate-pulse dark:bg-brand-400/10"></div>

          {/* Base Ring */}
          <div className="w-16 h-16 border-4 border-gray-100 dark:border-gray-800 rounded-full"></div>

          {/* Spinning Ring */}
          <div className="absolute w-16 h-16 border-4 border-t-brand-600 border-r-transparent border-b-transparent border-l-transparent rounded-full animate-spin"></div>

        </div>

        {/* TEXT */}
        <p className="mt-6 text-content-secondary text-sm font-medium tracking-wide text-center animate-pulse">
          {displayMessage.includes("Alchely") ? (
            displayMessage
          ) : (
            <>
              {displayMessage}
            </>
          )}
        </p>
      </div>
    </div>
  )
}
